import { useLocalSearchParams } from 'expo-router'

import type { INTENTION_TYPE } from '@/src/features/intention/models/Intention.enums'
import { IntentionPrayScreen } from '@/src/features/intention/ui/screens/IntentionPrayScreen'
import { routeToPath, type TIntentionsPraySearchParams } from '@/src/general/constants/routes'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { parseIdDash } from '@/src/general/utils/parseIdDash'
import { useRoutes } from '@/src/general/utils/routes'

const IntentionsPrayTypeRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const {
    idSharetoken,
    source = TRACKING_SOURCE.UNDEFINED,
    type,
    theme,
  } = filterSearchParams<{ idSharetoken: TIdDashSlug; type: INTENTION_TYPE } & TIntentionsPraySearchParams>(
    searchParams,
  )

  const { routes } = useRoutes()
  const fallbackRoute = routes.intentions(theme)
  const { handleBackPress } = useBackHandlePress(fallbackRoute)

  if (!idSharetoken || !type) return null

  const [intentionId] = parseIdDash(idSharetoken)

  return (
    <IntentionPrayScreen
      intentionId={intentionId}
      source={source}
      theme={theme}
      type={type}
      redirect={routeToPath(fallbackRoute)}
      onClose={handleBackPress}
    />
  )
}

export default IntentionsPrayTypeRouterPage
